import { useState } from "react";
import { demoChange } from "../shared/fixtures";
import type { EvidencePacket, Question } from "../shared/schema";
import { ChangeQueue } from "./components/ChangeQueue";
import { ChangeWorkspace } from "./components/ChangeWorkspace";
import { EvidenceRail } from "./components/EvidenceRail";
import { Header } from "./components/Header";
import { PacketDialog } from "./components/PacketDialog";
import { PreviewDialog } from "./components/PreviewDialog";
import { createDryRunPacket } from "./demo-packet";
import { InfoIcon } from "./icons";

export function App() {
  const [change, setChange] = useState(demoChange);
  const [packet, setPacket] = useState<EvidencePacket | null>(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [packetOpen, setPacketOpen] = useState(false);

  const updateQuestions = (questions: Question[]) => setChange((current) => ({ ...current, questions }));
  const runDryInterview = () => {
    setPacket(createDryRunPacket(change));
    setPreviewOpen(false);
  };

  return (
    <div className="app-shell">
      <Header />
      <div className="app-grid">
        <ChangeQueue />
        <ChangeWorkspace change={change} onQuestionsChange={updateQuestions} />
        <EvidenceRail change={change} packet={packet} onPreview={() => setPreviewOpen(true)} onOpenPacket={() => setPacketOpen(true)} />
      </div>
      <footer className="statusbar">
        <span><InfoIcon />{packet ? "Dry interview complete · No real phone call" : "Dry run · No real phone call"}</span>
        <button type="button" disabled={!packet} onClick={() => setPacketOpen(true)}>Create approval packet</button>
      </footer>
      <PreviewDialog change={change} isOpen={previewOpen} onClose={() => setPreviewOpen(false)} onRunDryInterview={runDryInterview} />
      <PacketDialog change={change} packet={packet} isOpen={packetOpen} onClose={() => setPacketOpen(false)} />
    </div>
  );
}
